<template>
  <div
    id="back-to-top"
    class="back-to-top"
    :class="{hide: isHidden}">
    <button
      class="back-to-top__btn"
      type="button"
      ref="backToTopBtn"
      @click.prevent="scrollUp">
      <span class="back-to-top__text u-vh">
        {{ gettext('Back to top') }}
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'BackToTop',

  props: {
    showAfterOffset: {
      type: Number,
      default: 800
    }
  },

  data() {
    return {
      yOffset: window.pageYOffset
    }
  },

  computed: {
    isHidden() {
      return this.yOffset < this.showAfterOffset
    }
  },

  watch: {
    isHidden(isHidden) {
      if (isHidden) this.$refs.backToTopBtn.blur()
    }
  },

  created() {
    window.addEventListener('scroll', this.scrollListener)
  },
  mounted() {
    this.$refs.backToTopBtn.addEventListener('click', function(e) {
      window._paq.push(['trackEvent', 'page-event', 'back-to-top', window.location])
    })
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollListener)
  },

  methods: {
    scrollListener() {
      this.yOffset = window.pageYOffset
    },
    scrollUp(e) {
      e.preventDefault()
      window.scrollTo(0, 0)
    }
  },
}
</script>



// WEBPACK FOOTER //
// js/BackToTop.vue